import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  logoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  logoMiddle: {
    marginLeft: 40,
    marginRight: 40
  },
  logo: {
    '& svg': {
      width: 70,
      height: 'auto'
    }
  },
  socialLogo: {
    '& svg': {
      width: 80,
      height: 'auto'
    }
  }
})

export default useStyles
